import type { ExperiencePayload, OpenEventsPayload, SessionPayload } from "./types";

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, {
    credentials: "same-origin",
    ...init,
    headers: {
      "content-type": "application/json",
      ...(init?.headers ?? {}),
    },
  });

  if (!response.ok) {
    const payload = (await response.json().catch(() => ({}))) as { error?: string };
    throw new Error(payload.error ?? "אירעה שגיאה. נסו שוב.");
  }

  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}

export const api = {
  session: () => request<SessionPayload>("/api/session"),
  logout: () => request<void>("/api/logout", { method: "POST" }),
  login: (code: string) =>
    request<void>("/api/login", { method: "POST", body: JSON.stringify({ code }) }),
  experience: () => request<ExperiencePayload>("/api/experience"),
  recordOpen: (dayId: string) =>
    request<void>("/api/open", { method: "POST", body: JSON.stringify({ dayId }) }),
  statusSession: () => request<SessionPayload>("/api/status-session"),
  statusLogin: (code: string) =>
    request<void>("/api/status-login", { method: "POST", body: JSON.stringify({ code }) }),
  opens: () => request<OpenEventsPayload>("/api/opens"),
};
